export default "/marketplace/listings";